// extracted by mini-css-extract-plugin
export default {"wrapper":"common-table_wrapper__syRZS","table":"common-table_table__nREUN","column-hovered":"common-table_column-hovered__dm8pd"};